export default function Footer() {
  return (
  <footer className="bg-white dark:bg-gray-900 border-t border-nitrr-border dark:border-gray-700 mt-16">
      <div className="container mx-auto px-4 py-12 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-1">
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="/icons/nitrr.svg" 
                alt="NIT Raipur Logo" 
                className="w-12 h-12 object-contain"
              />
              <div>
                <h3 className="font-bold text-lg text-nitrr-text dark:text-white">NITRR</h3>
                <p className="text-xs text-nitrr-text-muted dark:text-gray-400">Logo Library</p>
              </div>
            </div>
            <p className="text-nitrr-text-secondary text-sm dark:text-gray-400">
              Official logo library for NIT Raipur. Download logos for clubs, 
              committees, departments, and events.
            </p>
          </div>
          
          <div>
            <h3 className="font-bold text-lg mb-4 text-nitrr-text dark:text-white">
              Quick Links
            </h3>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="https://nitrr.ac.in" className="text-nitrr-text-secondary dark:text-gray-300 hover:text-nitrr-primary transition-colors">
                  NIT Raipur Official Website
                </a>
              </li>
              <li>
                <a href="https://nitrr.ac.in/stu_club.php" className="text-nitrr-text-secondary dark:text-gray-300 hover:text-nitrr-primary transition-colors">
                  Clubs & Committees
                </a>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="font-bold text-lg mb-4 text-nitrr-text dark:text-white">
              Usage Guidelines
            </h3>
            <p className="text-nitrr-text-secondary text-sm dark:text-gray-400">
              All logos are property of NIT Raipur and respective clubs. 
              Use only for official purposes.
            </p>
          </div>
          
          <div>
            <h3 className="font-bold text-lg mb-4 text-nitrr-text dark:text-white">
              Connect
            </h3>
            <div className="flex space-x-4">
              <a href="https://github.com" target="_blank" rel="noopener noreferrer" className="hover:opacity-70 transition-opacity">
                <img src="/icons/github.svg" alt="GitHub" className="w-6 h-6" />
              </a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="hover:opacity-70 transition-opacity">
                <img src="/icons/facebook.svg" alt="Facebook" className="w-6 h-6" />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="hover:opacity-70 transition-opacity">
                <img src="/icons/linkedin.svg" alt="LinkedIn" className="w-6 h-6" />
              </a>
              <a href="mailto:info@nitrr.ac.in" className="hover:opacity-70 transition-opacity">
                <img src="/icons/email.svg" alt="Email" className="w-6 h-6" />
              </a>
            </div>
          </div>
        </div>
        
        <div className="border-t border-nitrr-border mt-8 pt-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-nitrr-text-secondary text-sm text-center md:text-left">
              © 2025 National Institute of Technology Raipur. All rights reserved.
            </p>
            <div className="flex items-center gap-3">
              <span className="text-xs text-nitrr-text-muted">Built with:</span>
              <div className="flex items-center gap-2">
                <img src="/icons/react.svg" alt="React" className="w-5 h-5" title="React" />
                <img src="/icons/tailwindcss.svg" alt="Tailwind CSS" className="w-5 h-5" title="Tailwind CSS" />
                <img src="/icons/nodejs.svg" alt="Node.js" className="w-5 h-5" title="Node.js" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}
